module.exports = __webpack_public_path__ + "img/20191115131100360截图20190822131755995.b037c2a5.jpg";